import clsx from 'clsx';
import { ElementsIconProps } from '../components';

export function EsFinancialHealthIcon({ className, ...props }: ElementsIconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={clsx(className, 'h-5 w-5')}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#00A36C" />
      <path
        d="M7.5 8.75H15.75"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M7.5 12H15.75"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M7.5 15.25H13.5"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M6.25 8.98L6.92 9.64L8.04 8.52"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 12.23L6.92 12.89L8.04 11.77"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 15.48L6.92 16.14L8.04 15.02"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
